<template>
  <div class="mb-10">
    <template v-for="(jenjang, key) in jenjangs">
      <v-card :key="key" tile flat class="my-5">
        <v-list-item dense class="px-0">
          <v-list-item-content class="pa-5">
            <v-row>
              <v-col class="py-0 my-1" cols="12" md="4">
                <v-list-item class="px-0">
                  <v-list-item-avatar color="secondary">
                    <v-icon dark>mdi-google-classroom</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content class="py-0">
                    <div class="mb-1"><span class="body-3 grey--text">Jenjang</span></div>
                    <span class="info--text mb-0" style="font-size: 17px">
                      {{ $getDeepObj(jenjang, 'm_jenjang.singkat') }} ({{
                        $getDeepObj(jenjang, 'm_jenjang.keterangan')
                      }})
                    </span>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" md="8">
                <v-row>
                  <v-col cols="12" md="4">
                    <div class="mb-1"><span class="body-3 grey--text">Nama Daerah</span></div>
                    <span class="mb-0">
                      {{ $getDeepObj(ori, 'instansi.nama') }}
                    </span>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div class="mb-1"><span class="body-3 grey--text">Status KS Negeri</span></div>
                    <span class="mb-0">
                      <strong>{{ $getDeepObj(jenjang, 'jml_kasek_negeri') || 0 }}</strong> Orang
                    </span>
                  </v-col>
                  <v-col cols="12" md="4">
                    <div class="mb-1"><span class="body-3 grey--text">Status KS Swasta</span></div>
                    <span class="mb-0">
                      <strong>{{ $getDeepObj(jenjang, 'jml_kasek_swasta') || 0 }}</strong> Orang
                    </span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-divider class="mb-5 mt-4" />
            <v-row class="mt-1">
              <v-col class="py-0 my-1" cols="12" md="4">
                <v-list-item class="px-0">
                  <v-list-item-avatar color="error">
                    <v-icon dark>mdi-chart-pie</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content class="py-0">
                    <div><span class="body-3 grey--text">Informasi Data</span></div>
                    <div>
                      <div class="my-auto  v-btn v-btn--text subtitle-1 text-capitalize">
                        Persentase Penilaian
                        <v-icon dark :color="+jenjang.k_proses_peringkat_psp > 1 ? 'green' : 'red'" class="mb-0">
                          {{ +jenjang.k_proses_peringkat_psp > 1 ? 'mdi-check' : 'mdi-close' }}
                        </v-icon>
                      </div>
                      <div>
                        <v-btn
                          :disabled="!$allow('psp-peringkat-seleksi.save-kriteria')"
                          :color="+jenjang.k_proses_peringkat_psp > 1 ? 'success' : 'primary'"
                          class="elevation-1"
                          @click="onSetKriteria(jenjang)"
                        >
                          <v-icon left dark>
                            {{ +jenjang.k_proses_peringkat_psp >= 2 ? 'mdi-eye' : 'mdi-pencil' }}
                          </v-icon>
                          {{ +jenjang.k_proses_peringkat_psp >= 2 ? 'Lihat Kriteria' : '1. Set Kriteria' }}
                        </v-btn>
                      </div>
                      <div class="my-2">
                        <v-btn
                          v-if="+jenjang.k_proses_peringkat_psp === 2"
                          class="text-capitalize px-1 indigo--text body-2"
                          text
                          small
                          @click="onResetTahap(jenjang)"
                        >
                          <v-icon left dark>
                            mdi-lock-open
                          </v-icon>
                          Buka kembali tahap ini
                        </v-btn>
                      </div>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="12" md="8">
                <v-row>
                  <v-col class="py-0" cols="12" md="4">
                    <div><span class="body-3 grey--text">Informasi Data</span></div>
                    <div class="my-auto  v-btn v-btn--text subtitle-1 text-capitalize">
                      Penilaian KS
                      <v-icon dark :color="+jenjang.k_proses_peringkat_psp >= 4 ? 'green' : 'red'" class="mb-0">
                        {{ +jenjang.k_proses_peringkat_psp >= 4 ? 'mdi-check' : 'mdi-close' }}
                      </v-icon>
                    </div>
                    <div>
                      <v-btn
                        :color="+jenjang.k_proses_peringkat_psp >= 4 ? 'success' : 'primary'"
                        class="elevation-1"
                        :disabled="+jenjang.k_proses_peringkat_psp < 2 || !$allow('psp-peringkat-seleksi.save-nilai')"
                        @click="onDetailNilai(jenjang, 'nilai')"
                      >
                        <v-icon left dark>
                          {{ +jenjang.k_proses_peringkat_psp >= 4 ? 'mdi-eye' : 'mdi-pencil' }}
                        </v-icon>
                        {{ +jenjang.k_proses_peringkat_psp >= 4 ? 'Lihat Nilai' : '2. Pengaturan Nilai' }}
                      </v-btn>
                    </div>
                    <div class="my-2">
                      <v-btn
                        v-if="+jenjang.k_proses_peringkat_psp === 4"
                        class="text-capitalize px-1 indigo--text body-2"
                        text
                        small
                        @click="onResetTahap(jenjang)"
                      >
                        <v-icon left dark>
                          mdi-lock-open
                        </v-icon>
                        Buka kembali tahap ini
                      </v-btn>
                    </div>
                  </v-col>
                  <v-col class="py-0" cols="12" md="4">
                    <div><span class="body-3 grey--text">Informasi Data</span></div>
                    <div class="my-auto  v-btn v-btn--text subtitle-1 text-capitalize">
                      Pemeringkatan
                      <v-icon dark :color="+jenjang.k_proses_peringkat_psp >= 6 ? 'green' : 'red'" class="mb-0">
                        {{ +jenjang.k_proses_peringkat_psp >= 6 ? 'mdi-check' : 'mdi-close' }}
                      </v-icon>
                    </div>
                    <div>
                      <v-btn
                        :color="+jenjang.k_proses_peringkat_psp >= 6 ? 'success' : 'primary'"
                        class="elevation-1"
                        :disabled="
                          +jenjang.k_proses_peringkat_psp < 4 || !$allow('psp-peringkat-seleksi.save-prioritas')
                        "
                        @click="onDetailNilai(jenjang, 'peringkat')"
                      >
                        <v-icon left dark>
                          {{ +jenjang.k_proses_peringkat_psp >= 6 ? 'mdi-eye' : 'mdi-pencil' }}
                        </v-icon>
                        {{ +jenjang.k_proses_peringkat_psp >= 6 ? 'Lihat Peringkat' : '3. Pemeringkatan' }}
                      </v-btn>
                    </div>
                    <div class="my-2">
                      <v-btn
                        v-if="+jenjang.k_proses_peringkat_psp === 6"
                        class="text-capitalize px-1 indigo--text body-2"
                        text
                        small
                        @click="onResetTahap(jenjang)"
                      >
                        <v-icon left dark>
                          mdi-lock-open
                        </v-icon>
                        Buka kembali tahap ini
                      </v-btn>
                    </div>
                  </v-col>
                  <v-col class="py-0" cols="12" md="4">
                    <div><span class="body-3 grey--text">Informasi Data</span></div>
                    <div class="my-auto  v-btn v-btn--text subtitle-1 text-capitalize">
                      Ajuan Proporsi
                      <v-icon dark :color="+jenjang.k_proses_peringkat_psp >= 8 ? 'green' : 'red'" class="mb-0">
                        {{ +jenjang.k_proses_peringkat_psp >= 8 ? 'mdi-check' : 'mdi-close' }}
                      </v-icon>
                    </div>
                    <div>
                      <v-btn
                        :color="+jenjang.k_proses_peringkat_psp >= 8 ? 'success' : 'primary'"
                        class="elevation-1"
                        :disabled="+jenjang.k_proses_peringkat_psp < 6 || !$allow('psp-peringkat-seleksi.save-kuota')"
                        @click="onSetKuota(jenjang)"
                      >
                        <v-icon left dark>
                          {{ +jenjang.k_proses_peringkat_psp >= 8 ? 'mdi-eye' : 'mdi-pencil' }}
                        </v-icon>
                        {{ +jenjang.k_proses_peringkat_psp >= 8 ? 'Lihat Proporsi' : '4. Ajuan Proporsi' }}
                      </v-btn>
                    </div>
                    <div class="my-2">
                      <v-btn
                        v-if="+jenjang.k_proses_peringkat_psp >= 8 && +ori.k_tahap_peringkat_psp === 2"
                        class="text-capitalize px-1 indigo--text body-2"
                        text
                        small
                        @click="onResetTahap(jenjang)"
                      >
                        <v-icon left dark>
                          mdi-lock-open
                        </v-icon>
                        Buka kembali tahap ini
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </template>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'list-jenjang',
  data() {
    return {
      ori: {},
      kriteria: {},
      jenjangs: [],
    };
  },

  mounted() {
    this.fetchData();
  },

  methods: {
    ...mapActions('peringkat', ['detail']),

    fetchData() {
      this.detail({ action: 'seleksi' }).then(({ data }) => {
        this.ori = data;
        this.jenjangs = data.psp_peringkat_jenjangs || [];
      });
    },

    onResetTahap(jenjang) {
      const tahaps = {
        2: 'Set Kriteria',
        4: 'Penilaian Kepala Sekolah',
        6: 'Penentuan Prioritas',
        8: 'Penentuan Proporsi',
      };

      this.$confirm(
        `<span class="body-2 black--text">Anda yakin ingin membuka kembali Tahap <strong>${
          tahaps[jenjang.k_proses_peringkat_psp]
        }</strong> ?`,
        'Buka Tahap'
      ).then(() => {
        this.$emit('reset', jenjang.psp_peringkat_jenjang_id);
      });
    },

    onSetKriteria(jenjang) {
      this.$emit('kriteria', jenjang);
    },

    onSetKuota(jenjang) {
      this.$emit('kuota', { jenjang, instansi: this.ori.instansi || {} });
    },

    onDetailNilai(jenjang, type) {
      this.$emit('detail', { jenjang, type });
    },
  },
};
</script>

<style scoped></style>
